module.exports = __webpack_public_path__ + "static/media/forward.db1c2b3d.svg";